import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';
import { APPOINTMENT_STATUS, APPOINTMENT_PAYMENT_STATUS } from '../../constants';
import {
  isReserved,
  isPaidCash,
  isPaidOnline,
  isPaidOnlineFailed,
} from '../../../../common/helpers/appointments';

const PaymentDetailsStatus = ({ serviceId, dataForStatus }) => {
  const {
    status,
    paidInShop,
    canceledBy,
    allowMultipleServices,
    payment,
    appointmentServices,
    giftCardId,
    isPartiallyRefunded,
    isFullyRefunded,
    paymentStatus,
  } = dataForStatus;

  const getStatusNameAndClass = () => {
    if (paidInShop) {
      return {
        statusName: (
          <div>
            {t('appointment:payment_status.paid')}<br />
            <span className="c-status__span">{t('appointment:payment_status.cash')}</span>
          </div>
        ),
        statusClass: 'c-status--green',
      };
    }

    if (!giftCardId && isPaidCash(payment)) {
      return {
        statusName: (
          <div>
            {t('appointment:payment_status.paid')}<br />
            <span className="c-status__span">{t('appointment:payment_status.cash')}</span>
          </div>
        ),
        statusClass: 'c-status--green',
      };
    }

    if (status === APPOINTMENT_STATUS.canceled) {
      if (!canceledBy || !canceledBy.cancelByKind) {
        return {
          statusName: t('appointment:payment_status.canceled'),
          statusClass: 'c-status--grey',
        };
      }

      return {
        statusName: (
          <div>
            <span className="c-status__span">{t('appointment:payment_status.canceled')}</span>
            {t('appointment:payment_status.canceled')}<br />
          </div>
        ),
        statusClass: 'c-status--grey',
      };
    }

    if (isFullyRefunded) {
      return {
        statusName: t('appointment:payment_status.refunded'),
        statusClass: 'c-status--red',
      };
    }

    if (isPartiallyRefunded) {
      return {
        statusName: t('appointment:payment_status.partially_refunded'),
        statusClass: 'c-status--green',
      };
    }

    if (allowMultipleServices) {
      const services = appointmentServices.map(appService => appService.serviceId);
      if (services.indexOf(serviceId) === -1) {
        return {
          statusName: t('appointment:payment_status.unpaid'),
          statusClass: 'c-status--red',
        };
      }
    }

    if (isReserved(payment)) {
      return {
        statusName: t('appointment:payment_status.reserved'),
        statusClass: 'c-status--green',
      };
    }

    if (isPaidOnline(payment)) {
      if (paymentStatus === APPOINTMENT_PAYMENT_STATUS.partiallyPaid) {
        return {
          statusName: t('appointment:payment_status.partially_paid'),
          statusClass: 'c-status--green',
        };
      }
      
      return {
        statusName: t('appointment:payment_status.paid'),
        statusClass: 'c-status--green',
      };
    }

    if (isPaidOnlineFailed(payment)) {
      return {
        statusName: t('appointment:payment_status.payment_failed'),
        statusClass: 'c-status--red',
      };
    }

    return {
      statusName: t('appointment:payment_status.unpaid'),
      statusClass: 'c-status--red',
    };
  };

  const serviceStatus = getStatusNameAndClass();

  return (
    <div className={`c-status ${serviceStatus.statusClass}`}>{ serviceStatus.statusName }</div>
  );
};

PaymentDetailsStatus.propTypes = {
  serviceId: PropTypes.string.isRequired,
  dataForStatus: PropTypes.object.isRequired,
};

export default PaymentDetailsStatus;
